import React, { useState, useRef, useEffect } from "react";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";

const LayoutImage = ({ imageUrl, stands, targetStand }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageSize, setImageSize] = useState({ width: 1, height: 1 });
  const imgRef = useRef(null);
  const containerRef = useRef(null);

  const selectedStand = stands.find(stand => String(stand.code) === String(targetStand));

  useEffect(() => {
    if (imgRef.current && imageLoaded) {
      setImageSize({
        width: imgRef.current.clientWidth,
        height: imgRef.current.clientHeight,
        naturalWidth: imgRef.current.naturalWidth,
        naturalHeight: imgRef.current.naturalHeight,
      });
    }
  }, [imageLoaded]);

  const handleImageLoad = (e) => {
    setImageLoaded(true);
    setImageSize({
      width: e.target.clientWidth,
      height: e.target.clientHeight,
      naturalWidth: e.target.naturalWidth,
      naturalHeight: e.target.naturalHeight,
    });
  };

  const handleImageError = (e) => {
    console.error("❌ Image failed to load:", e);
    setImageLoaded(false);
  };


  useEffect(() => {
    if (selectedStand && imageLoaded && containerRef.current) {
      const scaleX = imageSize.width / imageSize.naturalWidth;
      const scaleY = imageSize.height / imageSize.naturalHeight;
      const adjustedX = selectedStand.x * scaleX;
      const adjustedY = selectedStand.y * scaleY;

      containerRef.current.scrollTo({
        left: adjustedX - containerRef.current.clientWidth / 2,
        top: adjustedY - containerRef.current.clientHeight / 2,
        behavior: "smooth",
      });
    }
  }, [selectedStand, imageLoaded, imageSize]);

  return (
    <div
      ref={containerRef}
      style={{ position: "relative", display: "inline-block", maxWidth: "100%", overflow: "auto", maxHeight: "80vh", border: "1px solid #ccc" }}
    >
      <Image
        ref={imgRef}
        src={imageUrl}
        alt="Pavilion Layout"
        fluid
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
      
      {imageLoaded && stands.map((stand) => {
        const standCode = String(stand.code);
        const isTarget = standCode === String(targetStand);
        
        if (typeof stand.x !== 'number' || typeof stand.y !== 'number' || !stand.box) {
          console.warn(`⚠️ Missing coordinates for stand ${standCode}`);
          return null;
        }

        // Scale positions based on image size
        const scaleX = imageSize.width / imageSize.naturalWidth;
        const scaleY = imageSize.height / imageSize.naturalHeight;
        const adjustedX = stand.x * scaleX;
        const adjustedY = stand.y * scaleY;

   
        const standWidth = Math.abs(stand.box[2][0] - stand.box[0][0]); 
        const standHeight = Math.abs(stand.box[2][1] - stand.box[0][1]); 


        const adjustedWidth = standWidth * scaleX;
        const adjustedHeight = standHeight * scaleY;

        
        const circleSize = Math.max(adjustedWidth, adjustedHeight, 20);

        return isTarget ? (
          <OverlayTrigger
            key={standCode}
            placement="top"
            overlay={<Tooltip>{`Stand ${standCode}: ${stand.text || ''}`}</Tooltip>}
          >
            <div
              style={{
                position: "absolute",
                top: `${adjustedY}px`,
                left: `${adjustedX}px`,
                width: `${circleSize}px`,
                height: `${circleSize}px`,
                backgroundColor: "rgba(255, 0, 0, 0.3)", 
                borderRadius: "50%",
                border: "2px solid red",
                boxShadow: "0 0 8px rgba(0,0,0,0.5)",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            />
          </OverlayTrigger>
        ) : null;
      })}
      
      {imageLoaded && !selectedStand && stands.length > 0 && (
        <div
          className="bg-danger text-white p-2"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            borderRadius: "5px"
          }}
        >
          Stand {targetStand} not found
        </div>
      )}
      
      {stands.length === 0 && imageLoaded && (
        <div
          className="bg-warning text-dark p-2"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            borderRadius: "5px"
          }}
        >
          No stand data available
        </div>
      )}
      
      <div
        className="bg-info text-white p-1"
        style={{
          position: "absolute",
          bottom: "10px",
          left: "10px",
          borderRadius: "5px",
          fontSize: "12px"
        }}
      >
        Total stands: {stands.length}
      </div>
    </div>
  );
};

export default LayoutImage;
